import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  TextField,
  MenuItem,
  RadioGroup,
  Radio,
  Button,
  DialogActions,
  capitalize,
} from "@material-ui/core";
import * as React from "react";
import {
  colors,
  RETRIEVE_FROM,
  WAREHOUSE_CONTENT_RETRIEVE_FROM,
} from "../constants/constants";
import ChipComponent from "../components/ChipComponent";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  companyData: any;
  retrieveDetails: any;
  equipments: any;
  uniqueNames: any;
  uniqueTypes: any;
  uniqueMachineNumbers: any;
  onClose: any;
  onSubmit: any;
  otherHeaders?: any;
  headerTitle?: any;
}
class RetrieveOptionsDialog extends React.Component<Props> {
  state = {
    companyData: false,
    equipmentData: false,
    customData: false,
    employeeData: false,
    warehouseContentData: false,
    selectedItem: "",
    equipmentSelectedRetrievalOption: "",
    selectedEmployeeItem: "",
    selectedWarehouseContentItem: "",
    equipmentNameSelected: "",
    filterBy: "",
    equipmentTypeNameSelected: "",
    equipments: Array<any>(),
    uniqueNames: Array<any>(),
    uniqueTypes: Array<any>(),
    uniqueMachineNumbers: Array<any>(),
    customDataItems: Array<any>(),
    customDataValue: { value: "", label: "" },
    results: {
      retriveOptionFrom: "",
      retrieveElement: "",
      secondaryRetriveElement: "",
      retrieveItems: Array<any>(),
      filterBy: "",
    },
  };

  componentDidMount = async () => {
    this.setDefaultValues();
  };
  componentDidUpdate = async (prevProps: any) => {
    if (prevProps.retrieveDetails !== this.props.retrieveDetails) {
      this.setState(
        {
          captureRetrieveOptions: false,
          companyData: false,
          equipmentData: false,
          customData: false,
          employeeData: false,
          warehouseContentData: false,
          selectedItem: "",
          equipmentSelectedRetrievalOption: "",
          equipmentNameSelected: "",
          equipmentTypeNameSelected: "",
          customDataItems: Array<any>(),
          customDataValue: { value: "", label: "" },
          results: {
            retriveOptionFrom: "",
            retrieveElement: "",
            secondaryRetriveElement: "",
            retrieveItems: Array<any>(),
          },
        },
        () => {
          this.setDefaultValues();
        }
      );
    }

    if (prevProps.uniqueNames !== this.props.uniqueNames) {
      this.setState({
        uniqueNames: this.props.uniqueNames,
      });
    }
  };

  setDefaultValues = () => {
    const {
      retrieveDetails,
      uniqueMachineNumbers,
      uniqueNames,
      uniqueTypes,
      equipments,
    } = this.props;
    let values: any = this.state;
    if (retrieveDetails && retrieveDetails.retriveOptionFrom) {
      if (retrieveDetails.retriveOptionFrom === "customData") {
        values.customData = true;
        values.companyData = false;
        values.equipmentData = false;
        values.employeeData = false;
        values.warehouseContentData = false;
      }
      if (retrieveDetails.retriveOptionFrom === "companyData") {
        values.companyData = true;
        values.customData = false;
        values.equipmentData = false;
        values.employeeData = false;
        values.warehouseContentData = false;
      }
      if (retrieveDetails.retriveOptionFrom === "equipmentData") {
        values.companyData = false;
        values.companyData = false;
        values.equipmentData = true;
        values.employeeData = false;
        values.warehouseContentData = false;
      }
      if (retrieveDetails.retriveOptionFrom === "employeeData") {
        values.companyData = false;
        values.companyData = false;
        values.equipmentData = false;
        values.employeeData = true;
        values.warehouseContentData = false;
      }
      if (retrieveDetails.retriveOptionFrom === "warehouseContentData") {
        values.companyData = false;
        values.companyData = false;
        values.equipmentData = false;
        values.employeeData = false;
        values.warehouseContentData = true;
      }
      values.results.retriveOptionFrom = retrieveDetails.retriveOptionFrom;
      if (retrieveDetails.retrieveItems) {
        values.customDataItems = retrieveDetails.retrieveItems;
        values.results.retrieveItems = retrieveDetails.retrieveItems;
      }
      if (retrieveDetails.retrieveElement) {
        values.selectedItem =
          retrieveDetails.retriveOptionFrom === "companyData"
            ? retrieveDetails.retrieveElement
            : "";
        values.equipmentSelectedRetrievalOption =
          retrieveDetails.retriveOptionFrom === "equipmentData"
            ? retrieveDetails.retrieveElement
            : "";
        values.selectedEmployeeItem =
          retrieveDetails.retriveOptionFrom === "employeeData"
            ? retrieveDetails.retrieveElement
            : "";
        values.selectedWarehouseContentItem =
          retrieveDetails.retriveOptionFrom === "warehouseContentData"
            ? retrieveDetails.retrieveElement
            : "";
        values.results.retrieveElement = retrieveDetails.retrieveElement;
      }
      if (retrieveDetails.secondaryRetriveElement) {
        values.results.secondaryRetriveElement =
          retrieveDetails.secondaryRetriveElement;
        values.equipmentNameSelected = retrieveDetails.secondaryRetriveElement;
        values.equipmentTypeNameSelected =
          retrieveDetails.secondaryRetriveElement;
      }
      if (retrieveDetails.filterBy) {
        values.results.filterBy = retrieveDetails.filterBy;
      }
    }
    this.setState({
      companyData: values.companyData,
      equipmentData: values.equipmentData,
      customData: values.customData,
      selectedItem: values.selectedItem,
      equipmentSelectedRetrievalOption: values.equipmentSelectedRetrievalOption,
      selectedEmployeeItem: values.selectedEmployeeItem,
      selectedWarehouseContentItem: values.selectedWarehouseContentItem,
      equipmentNameSelected: values.equipmentNameSelected,
      filterBy: values.results.filterBy,
      equipmentTypeNameSelected: values.equipmentTypeNameSelected,
      customDataItems: values.customDataItems,
      uniqueMachineNumbers: uniqueMachineNumbers,
      uniqueNames: uniqueNames,
      uniqueTypes: uniqueTypes,
      equipments: equipments,

      results: {
        retriveOptionFrom: values.results.retriveOptionFrom,
        retrieveElement: values.results.retrieveElement,
        secondaryRetriveElement: values.results.secondaryRetriveElement,
        retrieveItems: values.results.retrieveItems,
        filterBy: values.results.filterBy,
      },
    });
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleListItemClick = () => {
    this.props.onClose();
  };

  handleRemoveCustomDataChip = (item: any, index: any) => {
    let items = [...this.state.customDataItems];
    items.splice(index, 1);
    this.setState({
      customDataItems: items,
    });
  };

  handleOnSubmit = () => {
    let results = this.state.results;
    results.retrieveItems = this.state.customDataItems;
    results.filterBy = this.state.filterBy;
    let mValue = { ...results };
    this.props.onSubmit(mValue);
  };

  onCustomDataAddClicked = () => {
    if (this.state.customDataValue) {
      let currentCustomDataItems = this.state.customDataItems;
      currentCustomDataItems.push(this.state.customDataValue);
      this.setState({
        customDataItems: currentCustomDataItems,
        customDataValue: { value: "", label: "" },
      });
    }
  };

  render() {
    const { open, companyData, otherHeaders } = this.props;
    let companyDataOptions = new Array<any>();
    for (var property in companyData) {
      if (companyData[property] instanceof Array) {
        companyDataOptions.push({
          label: capitalize(property),
          value: property,
          elements: companyData[property],
        });
      }
    }
    return (
      <Dialog fullWidth={true} open={open} onClose={() => this.handleClose()}>
        <DialogTitle id="alert-dialog-title">{`Add Retrieve Options`}</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">Retrieve Options from:</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.companyData}
                    onChange={(event: any) => {
                      this.setState({
                        companyData: event.target.checked,
                        customDataItems: Array<any>(),
                        equipmentData: false,
                        employeeData: false,
                        warehouseContentData: false,
                        customData: false,
                      });
                    }}
                    name="jason"
                  />
                }
                label="Company Data"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.equipmentData}
                    onChange={(event: any) => {
                      this.setState(
                        {
                          equipmentData: event.target.checked,
                          customDataItems: Array<any>(),
                          companyData: false,
                          customData: false,
                        },
                        () => {
                          let result = {
                            retriveOptionFrom: "equipmentData",
                            retrieveElement: "",
                            retrieveItems: Array<any>(),
                          };
                          this.setState({
                            results: result,
                          });
                        }
                      );
                    }}
                    name="antoine"
                  />
                }
                label="Equipment Data"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.customData}
                    onChange={(event: any) => {
                      this.setState(
                        {
                          customData: event.target.checked,
                          companyData: false,
                          equipmentData: false,
                        },
                        () => {
                          let result = {
                            retriveOptionFrom: "customData",
                            retrieveElement: "",
                            retrieveItems: Array<any>(),
                          };
                          this.setState({
                            results: result,
                          });
                        }
                      );
                    }}
                    name="antoine"
                  />
                }
                label="Custom Data"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.employeeData}
                    onChange={(event: any) => {
                      this.setState({
                        employeeData: event.target.checked,
                        customDataItems: Array<any>(),
                        equipmentData: false,
                        customData: false,
                      });
                    }}
                    name="jason"
                  />
                }
                label="Employee Data"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.warehouseContentData}
                    onChange={(event: any) => {
                      this.setState({
                        warehouseContentData: event.target.checked,
                        customDataItems: Array<any>(),
                        equipmentData: false,
                        customData: false,
                        employeeData: false,
                      });
                    }}
                    name="jason"
                  />
                }
                label="Warehouse Content Data"
              />
            </FormGroup>
          </FormControl>
          {this.state.companyData && (
            <TextField
              style={{ margin: 10 }}
              select
              label={"Select item to retrieve from:"}
              margin="dense"
              value={this.state.selectedItem ? this.state.selectedItem : ""}
              onChange={(event) => {
                this.setState(
                  {
                    selectedItem: event.target.value,
                  },
                  () => {
                    let result = {
                      retriveOptionFrom: "companyData",
                      retrieveElement: this.state.selectedItem,
                      retrieveItems: Array<any>(),
                    };
                    this.setState({
                      results: result,
                    });
                  }
                );
              }}
              fullWidth
            >
              {companyDataOptions.map((option: any, index: any) => (
                <MenuItem key={index.toString()} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          )}
          {this.state.equipmentData && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FormControl component="fieldset">
                  <FormLabel component="legend">
                    Select item to retrieve from:
                  </FormLabel>
                  <RadioGroup
                    aria-label="retrieveElement"
                    name="retrieveElement"
                    value={
                      this.state.equipmentSelectedRetrievalOption
                        ? this.state.equipmentSelectedRetrievalOption
                        : ""
                    }
                    onChange={(event: any) => {
                      this.setState(
                        {
                          equipmentSelectedRetrievalOption: event.target.value,
                        },
                        () => {
                          let result = {
                            retriveOptionFrom: "equipmentData",
                            retrieveElement:
                              this.state.equipmentSelectedRetrievalOption,
                            retrieveItems: Array<any>(),
                          };
                          this.setState({
                            results: result,
                          });
                        }
                      );
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <FormControlLabel
                        value="equipmentType"
                        control={<Radio />}
                        label="Equipment Type"
                      />
                      <FormControlLabel
                        value="equipmentName"
                        control={<Radio />}
                        label="Equipment Name"
                      />
                      <FormControlLabel
                        value="machineNumber"
                        control={<Radio />}
                        label="Equipment Number"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </div>
              {this.state.equipmentSelectedRetrievalOption ===
                "equipmentType" && (
                <TextField
                  style={{ margin: 10 }}
                  select
                  label={"Equipment Name"}
                  placeholder={"Select Equipment Name"}
                  margin="dense"
                  value={
                    this.state.equipmentTypeNameSelected
                      ? this.state.equipmentTypeNameSelected
                      : ""
                  }
                  onChange={(event) => {
                    this.setState(
                      {
                        equipmentTypeNameSelected: event.target.value,
                      },
                      () => {
                        let result = this.state.results;
                        result.secondaryRetriveElement =
                          this.state.equipmentTypeNameSelected;
                        this.setState({
                          results: result,
                        });
                      }
                    );
                  }}
                  fullWidth
                >
                  <MenuItem value={"All"}>{"All"}</MenuItem>
                  {this.state.uniqueNames.map((option: any, index: any) => (
                    <MenuItem key={index.toString()} value={option.title}>
                      {option.title}
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {this.state.equipmentSelectedRetrievalOption ===
                "machineNumber" && (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <TextField
                    style={{ margin: 10 }}
                    select
                    label={"Equipment Name"}
                    placeholder={"Select Equipment Name"}
                    margin="dense"
                    value={
                      this.state.equipmentNameSelected
                        ? this.state.equipmentNameSelected
                        : ""
                    }
                    onChange={(event) => {
                      this.setState(
                        {
                          equipmentNameSelected: event.target.value,
                        },
                        () => {
                          let result = this.state.results;
                          result.secondaryRetriveElement =
                            this.state.equipmentNameSelected;
                          this.setState({
                            results: result,
                          });
                        }
                      );
                    }}
                    fullWidth
                  >
                    <MenuItem value={"All"}>{"All"}</MenuItem>
                    {this.state.uniqueNames.map((option: any, index: any) => (
                      <MenuItem key={index.toString()} value={option.title}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                  {this.state.equipmentNameSelected === "All" && (
                    <TextField
                      style={{ margin: 10 }}
                      select
                      label={"Filter by"}
                      placeholder={"Select a filter"}
                      margin="dense"
                      value={this.state.filterBy ? this.state.filterBy : ""}
                      onChange={(event) => {
                        this.setState(
                          {
                            filterBy: event.target.value,
                          },
                          () => {
                            let result = this.state.results;
                            result.filterBy = this.state.filterBy;
                            this.setState({
                              results: result,
                            });
                          }
                        );
                      }}
                      fullWidth
                    >
                      {this.props.otherHeaders
                        .filter((item: any) => {
                          return item.title !== this.props.headerTitle;
                        })
                        .map((option: any, index: any) => {
                          return (
                            <MenuItem
                              key={index.toString()}
                              value={option.title}
                            >
                              {option.title}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  )}
                </div>
              )}
            </div>
          )}
          {this.state.employeeData && (
            <TextField
              style={{ margin: 10 }}
              select
              label={"Select item to retrieve from:"}
              margin="dense"
              value={
                this.state.selectedEmployeeItem
                  ? this.state.selectedEmployeeItem
                  : ""
              }
              onChange={(event) => {
                this.setState(
                  {
                    selectedEmployeeItem: event.target.value,
                  },
                  () => {
                    let result = {
                      retriveOptionFrom: "employeeData",
                      retrieveElement: this.state.selectedEmployeeItem,
                      retrieveItems: Array<any>(),
                    };
                    this.setState({
                      results: result,
                    });
                  }
                );
              }}
              fullWidth
            >
              {RETRIEVE_FROM.map((option: any, index: any) => {
                if (option.value !== "none") {
                  return (
                    <MenuItem key={index.toString()} value={option.value}>
                      {option.label}
                    </MenuItem>
                  );
                }
                return null;
              })}
            </TextField>
          )}
          {this.state.warehouseContentData && (
            <TextField
              style={{ margin: 10 }}
              select
              label={"Select item to retrieve from:"}
              margin="dense"
              value={
                this.state.selectedWarehouseContentItem
                  ? this.state.selectedWarehouseContentItem
                  : ""
              }
              onChange={(event) => {
                this.setState(
                  {
                    selectedWarehouseContentItem: event.target.value,
                  },
                  () => {
                    let result = {
                      retriveOptionFrom: "warehouseContentData",
                      retrieveElement: this.state.selectedWarehouseContentItem,
                      retrieveItems: Array<any>(),
                    };
                    this.setState({
                      results: result,
                    });
                  }
                );
              }}
              fullWidth
            >
              {WAREHOUSE_CONTENT_RETRIEVE_FROM.map(
                (option: any, index: any) => {
                  if (option.value !== "none") {
                    return (
                      <MenuItem key={index.toString()} value={option.value}>
                        {option.label}
                      </MenuItem>
                    );
                  }
                  return null;
                }
              )}
            </TextField>
          )}
          {this.state.customData && (
            <div>
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <TextField
                  fullWidth
                  id="standard-basic"
                  label="Add custom data"
                  value={this.state.customDataValue.label}
                  placeholder="Add custom data"
                  onChange={(event: any) => {
                    let currentCustomDataValue = this.state.customDataValue;
                    currentCustomDataValue.value = event.target.value.includes(
                      "-"
                    )
                      ? event.target.value.toUpperCase()
                      : event.target.value.replace(" ", "-").toUpperCase();
                    currentCustomDataValue.label = event.target.value;
                    this.setState({
                      customDataValue: currentCustomDataValue,
                    });
                  }}
                />
                <Button
                  variant="outlined"
                  disabled={
                    this.state.customDataValue &&
                    this.state.customDataValue.label &&
                    this.state.customDataValue.value
                      ? false
                      : true
                  }
                  onClick={() => this.onCustomDataAddClicked()}
                  style={{ marginLeft: 20 }}
                >
                  ADD
                </Button>
              </div>
              {this.state.customDataItems.map((item: any, index: number) => {
                return (
                  <ChipComponent
                    key={`chip-pos:${index.toString()}`}
                    title={item.label}
                    item={item}
                    index={index}
                    chipValue={this.state.customDataValue}
                    isDisabled={this.state.customDataValue.label ? true : false}
                    onChipDelete={(mItem: any, nIndex: any) => {
                      this.handleRemoveCustomDataChip(mItem, nIndex);
                    }}
                    onChipEdit={(mItem: any, nIndex: any) => {
                      let customDataItems = this.state.customDataItems;
                      customDataItems.splice(nIndex, 1, mItem);
                      this.setState({
                        inspectionType: customDataItems,
                      });
                    }}
                  />
                );
              })}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleClose()} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => this.handleOnSubmit()}
            color="primary"
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(RetrieveOptionsDialog);
